module.exports = __webpack_public_path__ + "static/index-splash-xl-987cadd153bd8843d11e9d5553885d53.jpg";